export const EMPTY = Object.freeze({ kind: 'empty' });
export const WALL = Object.freeze({ kind: 'wall' });
/** Символы маски сосуда: '.' — клетка поля, '#' — стенка. */
export const MASK_OPEN = '.';
export const MASK_WALL = '#';
/** Ставит стенки по маске сосуда (строки сверху вниз). Без маски поле — прямоугольник. */
export function applyMask(board, mask) {
    if (!mask)
        return board;
    const cells = board.cells.slice();
    mask.forEach((row, y) => {
        for (let x = 0; x < row.length; x++) {
            if (row[x] === MASK_WALL)
                cells[indexOf(board, x, y)] = WALL;
        }
    });
    return { ...board, cells };
}
export function createBoard(width, height) {
    return { width, height, cells: new Array(width * height).fill(EMPTY) };
}
export function inBounds(board, x, y) {
    return x >= 0 && x < board.width && y >= 0 && y < board.height;
}
export function indexOf(board, x, y) {
    return y * board.width + x;
}
export function getCell(board, x, y) {
    const cell = inBounds(board, x, y) ? board.cells[indexOf(board, x, y)] : undefined;
    if (cell === undefined) {
        throw new RangeError(`cell (${x}, ${y}) is outside the ${board.width}×${board.height} board`);
    }
    return cell;
}
export function isEmptyCell(board, x, y) {
    return inBounds(board, x, y) && getCell(board, x, y).kind === 'empty';
}
export function countViruses(board) {
    return board.cells.reduce((n, cell) => (cell.kind === 'virus' ? n + 1 : n), 0);
}
//# sourceMappingURL=board.js.map